module.exports = "/_next/static/images/e85ee75e42f8ec2bd81ea70625a4eb66-cartao-proximo-ao-olho-lg@2x.jpg";